module.exports = __webpack_public_path__ + "static/yum_hero_logo-4c210126b183a44d267aab9cd8860cb9.png";